const footer = {
    policies : "Policies",
    privacy : "Privacy Policy",
    clinic_terms : "Terms of Use (rebless™ Clinic)",
    app_terms : "Terms of Use (rebless™ App)",
    contact : "Contact Us",
    social : "Follow Us"
};

export default footer;